<template>
  <div class="chat__container">
    <div class="chat__header spacex-12">
      <button type="button" class="d-contents spacex-4" @click="closeDialog">
        <Icon v-if="currentOffer" type="chevron-left" size="16" />
        <span>
          {{ dialogOffer ? chatTitle : $t('Chats') }}
        </span>
      </button>
    </div>
    <div v-if="dialogOffer">
      <Dialog :offer="dialogOffer" />
    </div>
    <div v-else class="preview__content spacey-10">
      <Spinner v-if="loading" size="24" class="mt-2" />
      <span v-if="offers.length" class="text-tertiary text-mm flex-centering">{{
        $t('Chats with subcontractors')
      }}</span>
      <OfferDialogPreview
        v-for="offer in offers"
        :key="offer.id"
        :offer="offer"
        @click="openDialog(offer)"
      />
    </div>
    <Info
      v-if="!isIncomingTender && !offers.length && !loading"
      class="chat-info"
      :title="$t('No invited companies yet')"
      :text="
        $t(
          'Invite your first contractor in Tender and when it applies your invitation, you\'ll see it here'
        )
      "
    />
  </div>
</template>

<script>
  import OfferDialogPreview from '@/containers/chat/DialogPreview';
  import Dialog from '@/containers/chat/Dialog';
  import Chevron from '@/assets/icons/chevron.svg';
  import Info from '@/components/chat/Info';
  import { mapState } from 'vuex';
  import Spinner from 'vue-simple-spinner';
  import factory from '@/utils/api/factory';
  import get from 'lodash.get';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Chat',
    components: {
      OfferDialogPreview,
      Dialog,
      Icon,
      Info,
      Spinner,
    },
    async created() {
      this.loading = true;
      try {
        await this.uploadOffers();
      } catch (e) {
        console.error(e);
      }

      this.loading = false;
    },
    computed: {
      ...mapState('tender', ['tenderInfo']),
      ...mapState('incomingTender', ['incomingTenderInfo']),
      tenderId() {
        return this.$route.params.tenderId || this.$route.params.incomingTenderId;
      },
      isIncomingTender() {
        return !!this.$route.params.incomingTenderId;
      },
      dialogOffer() {
        return this.isIncomingTender
          ? this.incomingTenderInfo.id
            ? this.incomingTenderInfo
            : null
          : this.currentOffer;
      },
      chatTitle() {
        return this.isIncomingTender
          ? `${this.$t('Chat with')} ${get(
              this.incomingTenderInfo,
              'tender.team.name',
              'general contractor'
            )}`
          : this.offerChatTitle;
      },
    },
    data() {
      return {
        currentOffer: null,
        chevronIcon: Chevron,
        offers: [],
        loading: true,
        offerChatTitle: this.$t('Chat'),
      };
    },
    methods: {
      openDialog(offer) {
        this.currentOffer = offer;
        this.offerChatTitle = offer.contractor_team.name;
      },
      async closeDialog() {
        await this.uploadOffers();
        this.currentOffer = null;
      },
      async uploadOffers() {
        if (!this.isIncomingTender) {
          let { data } = await factory('tender_messages').indexInPath('chats', {
            tender_id: this.tenderId,
          });
          this.offers = data;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .chat__container {
    background-color: $surface2;
  }

  .chat__header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;

    padding-left: 12px;
    color: $grey900;
    font-size: 16px;
    font-weight: 600;
    height: 40px;
    box-shadow: 0px -1px 0px 0px $grey100 inset, inset 1px 0 0 #dadde2;
    display: flex;
    align-items: center;
  }

  .preview__content {
    overflow: auto;
    max-height: calc(100vh - 152px);
    position: absolute;
    top: 40px;
    width: 100%;
    padding: 16px;
  }

  .chat-info {
    z-index: 1;
    position: absolute;
    top: 50%;
    margin: -50px 20px auto 20px;
  }
</style>
